import { render, staticRenderFns } from "./agentProfiles.vue?vue&type=template&id=8335065a&"
import script from "./agentProfiles.vue?vue&type=script&lang=js&"
export * from "./agentProfiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports